import React from "react";
import { Route, RouteComponentProps, Switch } from "react-router-dom";
import SubscriptionsNavigation from "./components/SubscriptionNavigation";
import OrganizationSubscriptionsEditPage from "./pages/Edit";
import OrganizationSubscriptionsEditNewPage from "./pages/EditNew";
import OrganizationSubscriptionsIndexPage from "./pages/Index";
import OrganizationInvoicesPage from "./pages/Invoices/pages/Index";

const OrganizationSubscriptionsPage = (props: RouteComponentProps) => {
	return (
		<div className="page-container">
			<SubscriptionsNavigation />
			<div className="content">
				<Switch>
					<Route exact path={props.match.url} component={OrganizationSubscriptionsIndexPage} />
					<Route path={`${props.match.url}/edit`} component={OrganizationSubscriptionsEditPage} />
					<Route path={`${props.match.url}/editNew`} component={OrganizationSubscriptionsEditNewPage} />
					<Route path={`${props.match.url}/invoices`} component={OrganizationInvoicesPage} />
				</Switch>
			</div>
		</div>
	);
};

export default OrganizationSubscriptionsPage;
